module.exports = __webpack_public_path__ + "img/nsmb-sunlei-2019.df79fcfd.png";